export default __webpack_public_path__ + "static/media/cyl_example_uplatnitel_za_butalo.29581712.png";